import { action } from 'satcheljs';
import { EntityCommand } from '@office-start/nova-facade-types';

export const onComposeMessageExtensionTrigger = action(
    'onComposeMessageExtensionTrigger',
    (command: EntityCommand, hostId: string, contextMenuHostId: string, tabId: string) => ({
        command,
        hostId,
        contextMenuHostId,
        tabId,
    })
);
